import { VIEW } from 'types/deck'

import useDeckActions from 'components/deckPage/actions/menuActions'
import { useMobileControlToggles } from 'hooks/useMobileControlToggles.module'
import { useHideFloatingToolbar } from 'hooks/useBrowserSettings'
import { useAppSelector } from 'app-redux/hooks'

import { SubComponentProps } from 'components/elements/FloatingToolbar/types'

import PhatButton from 'components/formElements/PhatButton'
import Link from 'components/elements/Link'
import ToggleSwitch from 'components/formElements/ToggleSwitch'

import styles from './mobileDeckMoreMenu.module.scss'

const MobileDeckMoreMenu = ({ onClose }: SubComponentProps) => {
  const actions = useDeckActions(onClose)

  const playtesterButton = actions.playtester.to ? (
    <Link href={actions.playtester.to}>
      <PhatButton onClick={actions.playtester.onClick} icon={actions.playtester.icon}>
        {actions.playtester.label}
      </PhatButton>
    </Link>
  ) : (
    <PhatButton onClick={actions.playtester.onClick} icon={actions.playtester.icon}>
      {actions.playtester.label}
    </PhatButton>
  )

  return (
    <div className={styles.prominent}>
      {playtesterButton}

      <PhatButton onClick={actions.settings.onClick} icon={actions.settings.icon} disabled={actions.settings.hidden}>
        {actions.settings.label}
      </PhatButton>
    </div>
  )
}

export default MobileDeckMoreMenu

export const MobileDeckMoreMenuBottom = () => {
  const view = useAppSelector(state => state.deck.view)

  const [mobileControls, setMobileControls] = useMobileControlToggles()
  const [staticFloatingToolbar, setStaticFloatingToolbar] = useHideFloatingToolbar()

  return (
    <div className={styles.options}>
      <div className={styles.header}>Options</div>

      <ToggleSwitch
        label="Hide toolbar on scroll"
        onChange={() => setStaticFloatingToolbar(!staticFloatingToolbar)}
        checked={!staticFloatingToolbar}
        className={styles.toggle}
      />

      {view !== VIEW.LIST && (
        <ToggleSwitch
          label="Pin vertical toolbar adjacent to deck"
          onChange={() => setMobileControls({ stickyBar: !mobileControls.stickyBar })}
          checked={mobileControls.stickyBar}
          className={styles.toggle}
        />
      )}
    </div>
  )
}
